import { render, staticRenderFns } from "./PersonnelRecordsList.vue?vue&type=template&id=3c3d54fa"
import script from "./PersonnelRecordsList.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports